module.exports = __webpack_public_path__ + "img/times-solid.ef4cbfa8.svg";